// Multivariate Dependencies
import { useMemo } from 'react';
// Utils
import { appendDropdownOptionToEnd } from '../utils/appendDropdownOptionToEnd';
import { generateFetchAndSetDropdownOptionsDebounced } from '../utils/generateFetchAndSetDropdownOptionsDebounced';
import { handleSelectOption } from '../utils/handleSelectOption';
import { handleDropdownInputValue } from '../utils/handleDropdownInputValue';
import { DefaultTimeouts } from '../types/DefaultTimeouts';
export var useDropdownSearchers = function (selectedDropdownOption, onDropdownOptionSelected, getDropdownOptions, focusOnTheDropdownInput, dispatch, fetchDropdownOptionDelay) {
    if (fetchDropdownOptionDelay === void 0) { fetchDropdownOptionDelay = DefaultTimeouts.FetchDelay; }
    var fetchAndSetDropdownOptionsDebounced = useMemo(function () {
        return generateFetchAndSetDropdownOptionsDebounced(selectedDropdownOption, appendDropdownOptionToEnd(selectedDropdownOption), getDropdownOptions, dispatch, handleSelectOption(onDropdownOptionSelected, focusOnTheDropdownInput, dispatch));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedDropdownOption, onDropdownOptionSelected, getDropdownOptions, dispatch]);
    var fetchAndSetDropdownOptionsWithDelay = useMemo(function () { return fetchAndSetDropdownOptionsDebounced(fetchDropdownOptionDelay); }, [fetchAndSetDropdownOptionsDebounced, fetchDropdownOptionDelay]);
    var fetchAndSetDropdownOptionsImmediately = useMemo(function () { return fetchAndSetDropdownOptionsDebounced(0); }, [fetchAndSetDropdownOptionsDebounced]);
    var handleSearch = handleDropdownInputValue(dispatch);
    return {
        searchWithDelay: handleSearch(fetchAndSetDropdownOptionsWithDelay),
        searchImmediately: handleSearch(fetchAndSetDropdownOptionsImmediately),
    };
};
//# sourceMappingURL=useDropdownSearchers.js.map